// extracted by css-extract-rspack-plugin
export default {"smallText":"pelRxm1XgpwgqGNg","smallTextInfo":"X_YGFY_vKu0jSRcx","checkbox":"Z6aYbdvZj1sPWdZi"};